document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener('baseline:cart:afteradditem', () => {
            Alpine.store('modals').closeAll();

            Alpine.store('modals').open('cart');
          });
        }
        window.addEventListener('baseline:cart:afteradditem', (e) => {
          this._setFromFetchedSection(e.detail.response);
        });
        Alpine.store('modals').register('cart', 'rightDrawer');
      },
      _setFromFetchedSection(data, elementId) {
        const sectionHtml = data.sections['atc-notification'];
        const notificationEle = querySelectorInHTMLString('#content', sectionHtml);
        if (notificationEle) {
          Alpine.store('notifications').open(
            notificationEle.innerHTML
        )
        }

      }
    };
  });

});
